// This file is autogenerated. Any changes will be overwritten.

import useUID from '../../../hooks/useUID';

export const set = 'streamline';

export const name = 'rule-library-solid';

export const Component = () => {
  const maskId = useUID();

  return (
    <>
      <defs>
        <mask id={maskId} fill='#000' stroke='#000' strokeLinecap='round'>
          <path fill='#fff' stroke='#fff' d='M0 0h18v18H0z' />
          <path d='M5.472 3.672h4.104M5.472 6.336h4.104M5.472 8.928h4.104m-4.104 2.664h4.104' />
          <path
            fill='#fff'
            d='m12.24 10.584 1.08 1.512 1.152-1.512m-2.232-5.76 1.08-1.512 1.152 1.512'
          />
        </mask>
      </defs>
      <g stroke='currentColor' strokeLinecap='round'>
        <path
          fill='currentColor'
          d='M3.96.576h12.384c.648 0 1.152.504 1.152 1.152v12.384c0 .648-.504 1.152-1.152 1.152H3.96a1.137 1.137 0 0 1-1.152-1.152V1.656c0-.576.504-1.08 1.152-1.08Z'
          mask={`url(#${maskId})`}
        />
        <path fill='none' d='M15.192 17.424H1.656a1.137 1.137 0 0 1-1.152-1.152V2.808' />
      </g>
    </>
  );
};

export const viewBox = '0 0 18 18';
